import React, { useEffect, useState, createElement } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import ContentSection from './components/ContentSection';
import BonusSection from './components/BonusSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import GuaranteeSection from './components/GuaranteeSection';
import FinalCTA from './components/FinalCTA';
import SocialProofPopup from './components/SocialProofPopup';
export function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const purchases = [{
    name: 'María González',
    city: 'Buenos Aires'
  }, {
    name: 'Carlos Rodríguez',
    city: 'Córdoba'
  }, {
    name: 'Laura Fernández',
    city: 'Rosario'
  }, {
    name: 'Diego Martínez',
    city: 'Mendoza'
  }, {
    name: 'Ana López',
    city: 'La Plata'
  }, {
    name: 'Roberto Sánchez',
    city: 'San Miguel de Tucumán'
  }, {
    name: 'Gabriela Pérez',
    city: 'Mar del Plata'
  }, {
    name: 'Martín Torres',
    city: 'Salta'
  }, {
    name: 'Claudia Ramírez',
    city: 'Santa Fe'
  }, {
    name: 'Fernando Castro',
    city: 'San Juan'
  }];
  useEffect(() => {
    // Meta Pixel inline injection
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', '1758908918422357');
    (window as any).fbq('track', 'PageView');
    const showRandomPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    };
    const interval = setInterval(() => {
      showRandomPopup();
    }, Math.random() * 7000 + 8000);
    return () => clearInterval(interval);
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <ContentSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <SocialProofPopup show={showPopup} name={currentPurchase.name} city={currentPurchase.city} data-id="element-11" />
    </div>;
}